import React from "react";
// import logo from "./maamaaslog.png";

const Deletion = () => {
    return (
        <div style={styles.wrapper}>
            {/* RESPONSIVE CSS */}
            <style>
                {`
          @media (max-width: 600px) {
            .header-box {
              flex-direction: column !important;
              text-align: center !important;
              gap: 10px !important;
            }
            .header-logo {
              margin-top: 0 !important;
            }
            .section-box {
              padding: 15px !important;
            }
          }
        `}
            </style>

            {/* HEADER */}
            <div className="header-box" style={styles.header}>
                <h1 style={styles.title}>Maamaa’s Account Deletion Guide</h1>
                {/* <img src={logo} alt="Logo" className="header-logo" style={styles.logo} /> */}
            </div>

            {/* MAIN CARD */}
            <div style={styles.card} className="section-box">
                <h2 style={styles.heading}>How to Delete Your Account</h2>

                <p>Follow these steps to permanently delete your Maamaa’s account:</p>

                <ol style={styles.list}>
                    <li>Open the Maamaa’s app on your device.</li>
                    <li>Go to <strong>Profile → Account Settings</strong>.</li>
                    <li>Tap <strong>Delete Account</strong>.</li>
                    <li>Read all warnings and consequences.</li>
                    <li>Check both confirmation boxes:</li>

                    <ul>
                        <li>“I understand the consequences”</li>
                        <li>“I confirm I want to delete my account”</li>
                    </ul>

                    <li>Tap <strong>DELETE MY ACCOUNT</strong>.</li>
                    <li>Confirm once more in the popup dialog.</li>
                </ol>

                <p style={styles.note}>
                    ✔ Once deleted, all your personal data, order history, addresses, and account information will be permanently removed from our servers.
                </p>

                <p style={styles.note}>
                    ⚠ Some anonymized data may be retained strictly for legal or regulatory purposes.
                </p>
            </div>

            {/* SECOND CARD */}
            <div style={styles.card} className="section-box">
                <h2 style={styles.heading}>If You Cannot Access the App</h2>

                <p>
                    You can request manual account deletion by contacting our support team:
                </p>

                <p style={styles.contactBox}>
                    <strong>Email:</strong> envisionis.it@gmail.com
                </p>

                <p>
                    When sending your request, include the <strong>email or phone number</strong> linked to
                    your Maamaa’s account so we can verify your identity.
                </p>
            </div>
        </div>
    );
};

const styles = {
    wrapper: {
        maxWidth: "1200px",
        margin: "auto",
        padding: "20px",
        fontFamily: "Arial, sans-serif",
        marginTop: "0px",
    },
    header: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        borderBottom: "3px solid #efefef",
        paddingBottom: "15px",
        marginBottom: "20px",
    },
    title: {
        fontSize: "26px",
        fontWeight: "bold",
        color: "#222",
    },
    logo: {
        width: "70px",
        height: "70px",
        objectFit: "contain",
    },
    card: {
        background: "#fff",
        padding: "25px",
        borderRadius: "12px",
        boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
        marginBottom: "25px",
    },
    heading: {
        fontSize: "20px",
        marginBottom: "10px",
        color: "#333",
    },
    list: {
        marginTop: "10px",
        lineHeight: 1.7,
    },
    note: {
        background: "#f8f9fa",
        padding: "10px 12px",
        borderRadius: "8px",
        marginTop: "10px",
        borderLeft: "4px solid #007bff",
    },
    contactBox: {
        background: "#eef7ff",
        padding: "10px 14px",
        borderRadius: "8px",
        margin: "10px 0",
        borderLeft: "4px solid #007bff",
    },
};

export default Deletion;
